import { render, staticRenderFns } from "./serviceacentekomisyon.vue?vue&type=template&id=5ebf0fb6&"
import script from "./serviceacentekomisyon.vue?vue&type=script&lang=js&"
export * from "./serviceacentekomisyon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports